import React from 'react';

interface DevsuLogoIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const DevsuLogoIcon: React.FC<DevsuLogoIconProps> = ({
  width = 29,
  height = 29,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_devsu_icon)">
        <path
          d="M17.7233 0H3.9019C1.74689 0 0 1.62266 0 3.62543C0 5.62819 1.74689 7.25085 3.9019 7.25085H17.7233C19.8783 7.25085 21.6252 5.62819 21.6252 3.62543C21.6252 1.62266 19.8783 0 17.7233 0Z"
          fill="url(#paint0_linear_devsu_icon)"
        />
        <path
          d="M17.7233 21.7507H3.9019C1.74689 21.7507 0 23.3734 0 25.3762C0 27.3789 1.74689 29.0016 3.9019 29.0016H17.7233C19.8783 29.0016 21.6252 27.3789 21.6252 25.3762C21.6252 23.3734 19.8783 21.7507 17.7233 21.7507Z"
          fill="url(#paint1_linear_devsu_icon)"
        />
        <path
          d="M3.82847 18.1259C5.94288 18.1259 7.65694 16.5027 7.65694 14.5004C7.65694 12.4982 5.94288 10.875 3.82847 10.875C1.71406 10.875 0 12.4982 0 14.5004C0 16.5027 1.71406 18.1259 3.82847 18.1259Z"
          fill="#03BA99"
        />
        <path
          d="M25.0327 10.875H15.1097C12.9957 10.875 11.2812 12.4977 11.2812 14.5004C11.2812 16.5032 12.9957 18.1259 15.1097 18.1259H25.0327C27.1467 18.1259 28.8611 16.5032 28.8611 14.5004C28.8611 12.4977 27.1467 10.875 25.0327 10.875Z"
          fill="#05EE6C"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_devsu_icon"
          x1="0"
          y1="3.62543"
          x2="21.6235"
          y2="3.62543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#03BA99" />
          <stop offset="1" stopColor="#05EE6C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_devsu_icon"
          x1="0"
          y1="25.3762"
          x2="21.6235"
          y2="25.3762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#03BA99" />
          <stop offset="1" stopColor="#05EE6C" />
        </linearGradient>
        <clipPath id="clip0_devsu_icon">
          <rect width="28.8611" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
